module.exports = __webpack_public_path__ + "img/6.baa0f5b4.jpg";